<div class="unauthorized-container">
  <div class="unauthorized-content">
    <div class="error-code"></div>
    <h1>{{ 'webPos.Unauthorized' | translate }}</h1>
    <p class="error-message">
      {{ 'webPos.UnauthorizedMessage' | translate }}
    </p>
    <p class="error-description">
      {{ 'webPos.UnauthorizedDescription' | translate }}
    </p>
    
    <div class="action-buttons">
      
    </div>
  </div>
</div>
